import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getArticleBySlug } from '../../services/blogApi';
import './ViewArticle.css';

export default function ViewArticle() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadArticle = async () => {
      try {
        const response = await getArticleBySlug(slug);
        setArticle(response.data);
      } catch (err) {
        setError(err.response?.data?.error || 'Article not found');
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      loadArticle();
    }
  }, [slug]);

  if (loading) {
    return <div className="view-article-container"><div className="loading">Loading article...</div></div>;
  }

  if (error || !article) {
    return (
      <div className="view-article-container">
        <div className="error">{error || 'Article not found'}</div>
        <button onClick={() => navigate('/blog')} className="back-button">Back to Articles</button>
      </div>
    );
  }

  return (
    <div className="view-article-container">
      <article className="article-content">
        <header className="article-header">
          <h1>{article.title}</h1>
          {article.description && <p className="article-description">{article.description}</p>}
          <div className="article-meta">
            <span className="author">By {article.authorUsername}</span>
            {article.publishedAt && (
              <span className="date">
                {new Date(article.publishedAt).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </span>
            )}
            {article.viewCount > 0 && <span className="views">{article.viewCount} views</span>}
          </div>
        </header>

        {article.coverImageUrl && (
          <div className="cover-image">
            <img src={article.coverImageUrl} alt={article.title} />
          </div>
        )}

        <div
          className="article-body"
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
      </article>
    </div>
  );
}

